import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65a30c2c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=65a30c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a30c2c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SidebarItem: require('D:/phpstudy_pro/WWW/disk/components/Sidebar/Item.vue').default,FolderSelect: require('D:/phpstudy_pro/WWW/disk/components/FolderSelect/index.vue').default,ModelConfirm: require('D:/phpstudy_pro/WWW/disk/components/ModelConfirm/index.vue').default})
